export interface ServiceApiResource {
  id: string;
  name_en: string;
  name_pl: string;
  description_en: string | null;
  description_pl: string | null;
  preparation_en: string | null;
  preparation_pl: string | null;
  price_minor_units: number | null;
  currency: string;
  therapy_type: string | null;
  is_active: boolean;
  sort_order: number;
}

export interface OwnerServiceApiResource {
  id: string;
  name_en: string;
  name_pl: string;
  description_en: string | null;
  description_pl: string | null;
  preparation_en: string | null;
  preparation_pl: string | null;
  price_minor_units: number | null;
  currency: string;
  therapy_type: string | null;
}

export interface Service {
  id: string;
  nameEn: string;
  namePl: string;
  descriptionEn: string | null;
  descriptionPl: string | null;
  preparationEn: string | null;
  preparationPl: string | null;
  priceMinorUnits: number | null;
  currency: string;
  therapyType: string | null;
  isActive: boolean;
  sortOrder: number;
}

export interface OwnerService {
  id: string;
  nameEn: string;
  namePl: string;
  descriptionEn: string | null;
  descriptionPl: string | null;
  preparationEn: string | null;
  preparationPl: string | null;
  priceMinorUnits: number | null;
  currency: string;
  therapyType: string | null;
}

export interface ServiceWritePayload {
  nameEn: string;
  namePl: string;
  descriptionEn: string | null;
  descriptionPl: string | null;
  preparationEn: string | null;
  preparationPl: string | null;
  priceMinorUnits: number | null;
  currency: string | null;
  therapyType: string | null;
  isActive: boolean;
  sortOrder: number;
}

export function mapApiResourceToService(resource: ServiceApiResource): Service {
  return {
    id: resource.id,
    nameEn: resource.name_en,
    namePl: resource.name_pl,
    descriptionEn: resource.description_en,
    descriptionPl: resource.description_pl,
    preparationEn: resource.preparation_en,
    preparationPl: resource.preparation_pl,
    priceMinorUnits: resource.price_minor_units,
    currency: resource.currency,
    therapyType: resource.therapy_type,
    isActive: resource.is_active,
    sortOrder: resource.sort_order,
  };
}

export function mapApiResourceToOwnerService(resource: OwnerServiceApiResource): OwnerService {
  return {
    id: resource.id,
    nameEn: resource.name_en,
    namePl: resource.name_pl,
    descriptionEn: resource.description_en,
    descriptionPl: resource.description_pl,
    preparationEn: resource.preparation_en,
    preparationPl: resource.preparation_pl,
    priceMinorUnits: resource.price_minor_units,
    currency: resource.currency,
    therapyType: resource.therapy_type,
  };
}

export function mapServiceWritePayload(payload: ServiceWritePayload): Record<string, unknown> {
  return {
    name_en: payload.nameEn,
    name_pl: payload.namePl,
    description_en: payload.descriptionEn,
    description_pl: payload.descriptionPl,
    preparation_en: payload.preparationEn,
    preparation_pl: payload.preparationPl,
    price_minor_units: payload.priceMinorUnits,
    currency: payload.currency,
    therapy_type: payload.therapyType,
    is_active: payload.isActive,
    sort_order: payload.sortOrder,
  };
}
